import * as React from "react";

function SvgAddIcon(props) {
  return (
    <svg data-name="Livello 1" viewBox="0 0 151.57 151.57" {...props}>
      <circle
        cx={75.78}
        cy={75.78}
        r={72.28}
        fill="#FC5185"
        stroke="#f2f2f2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={7}
      />
      <path
        fill="#da2244"
        stroke="#f2f2f2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={7}
        d="M75.78 115.68V35.89M33.43 75.83h84.71"
      />
    </svg>
  );
}

export default SvgAddIcon;
